import { render, staticRenderFns } from "./testingPublicity.vue?vue&type=template&id=80a47770&scoped=true&"
import script from "./testingPublicity.vue?vue&type=script&lang=js&"
export * from "./testingPublicity.vue?vue&type=script&lang=js&"
import style0 from "./testingPublicity.vue?vue&type=style&index=0&id=80a47770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a47770",
  null
  
)

export default component.exports